import defaultRestApi from "../common/RestApiInstance";
import APIs from "../common/APIs";
import axios from 'axios';
import querystring from 'query-string';
import { E_SPORT_ID } from "../common/Foundation";


const CancelToken = axios.CancelToken;
let cancel;
export default class OddsServices {

  static getStartBetAPI = () => {
    return defaultRestApi.get(APIs.startBetURL());
  }  

  static getTeaserEvents = (data) => {
    if(cancel) {
      cancel();
    }
    return defaultRestApi.get(APIs.teaserOddsURL(querystring.stringify(data)), {
      cancelToken: new CancelToken(function executer(c) {
        cancel = c;
      })
    }).catch(err => {
      if(!axios.isCancel(err)) {
        // console.log(err);
      }
      return err;
    });
  }

  static getClassicOutrightEvents = (data) => {
    if(cancel) {
      cancel();
    }
    return defaultRestApi.get(APIs.outrightOddsClassicURL(querystring.stringify(data)), {
      cancelToken: new CancelToken(function executer(c) {
        cancel = c;
      })
    }).catch(err => {
      if(!axios.isCancel(err)) {
        // console.log(err);
      }
    });
  }

  static getClassicDataAPI = (country) => {
    return defaultRestApi.get(APIs.classicSportsMarketURL(country));
  }

  static getEvents = (data) => {
    if(cancel) {
      cancel();
    }
    return defaultRestApi.get(APIs.oddsEventsURL(querystring.stringify(data)), {
      cancelToken: new CancelToken(function executer(c) {
        cancel = c;
      })
    }).catch(err => {
      if(!axios.isCancel(err)) {
        
      }
    });
  }

  static getCompactEvents = (data) => {
    if(cancel) {
      cancel();
    }
    return defaultRestApi.get(APIs.oddsCompactEventsURL(querystring.stringify(data)), {
      cancelToken: new CancelToken(function executer(c) {
        cancel = c;
      })
    }).catch(err => {
      if(!axios.isCancel(err)) {
        
      }
    });
  }

  static getCompactFavouriteEvents = (data) => {
    if(cancel) {
      cancel();
    }
    return defaultRestApi.get(APIs.oddsCompactFavouriteEventsURL(querystring.stringify(data)), {
      cancelToken: new CancelToken(function executer(c) {
        cancel = c;
      })
    }).catch(err => {
      if(!axios.isCancel(err)) {
        
      }
    });
  }

  static loadMoreBetsEvents = (params) => {
    const url = APIs.oddsCompactEventsURL(querystring.stringify(params));
    return defaultRestApi.get(url);
  }

  static getLeagues = (params) => {
    return defaultRestApi.get(APIs.getCompactLeaguesURL(querystring.stringify(params)))
  }

  static getOutrightLeagues = (params) => {
    return defaultRestApi.get(APIs.getOutrightLeaguesURL(querystring.stringify(params)))
  }

  static getEsportLeagues = (params) => {
    return defaultRestApi.get(APIs.getEsportLeaguesURL(querystring.stringify(params)))
  }

  static getOutrightEvents = (sportId, data) => {
    if(cancel) {
      cancel();
    }

    const params = querystring.stringify(data);
    const url = sportId == E_SPORT_ID ? APIs.esportOutrightOddsURL(params) :  APIs.outrightOddsURL(params);

    return defaultRestApi.get((url), {
      cancelToken: new CancelToken(function executer(c) {
        cancel = c;
      })
    }).catch(err => {
      if(!axios.isCancel(err)) {
        // console.log(err);
      }
    });
  }


  static getSearchSuggestions = (data) => {
    return defaultRestApi.get(APIs.searchSuggestionsURL(querystring.stringify(data)));
  }

  static getSearchNormalEvents = (data) => {
    return defaultRestApi.get(APIs.searchEventsURL(querystring.stringify(data)));
  }

  static getSearchOutrightEvents = (sportId, data) => {
    const params = querystring.stringify(data);
    return defaultRestApi.get(
      sportId === E_SPORT_ID
      ? APIs.esportOutrightOddsURL(params)
      : APIs.outrightOddsURL(params)
    );
  }

  static getMatchupNavigation = (eventId) => {
    return defaultRestApi.get(APIs.getMatchupNavigation(querystring.stringify(eventId)), {
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/services/OddsServices.js